// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace TeamActions {
  export class Get {
    static readonly type = '[Team] Get';
    constructor(public id: number) {}
  }

  export class GetIndex {
    static readonly type = '[Team] GetIndex';
    constructor() {}
  }
}
